export class ListAIAgentSessions502Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAIAgentSessions502Response.attributeTypeMap;
    }
    constructor() {
    }
}
